/**
 * desc: performance上报watcher
 * dev: xuanzhou
 */

import { getChannelInfo } from '@common-libs/tj-channel'
import { getPlatform } from '@common-libs/tj-utils/platform'
import urlHelper from '@lib/utils/urlHelper'
import axios from '../services/request'

const sendWatcher = (metrics) => {
  return axios.post('/bnbapp-node-h5/h5/watcher/report', {
    parameter: {
      metrics
    }
  })
}

const getTiming = () => new Promise((resolve) => {
  const performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance
  let timing = {}
  if (!performance?.timing) {
    return timing
  }
  if (performance.timing.toJSON) {
    timing = performance.timing.toJSON()
  } else {
    timing = performance.timing
  }

  /**
   * 用户可操作时间
   */
  timing.domReadyTime = timing.domContentLoadedEventEnd - timing.navigationStart

  /**
   * http://javascript.ruanyifeng.com/bom/performance.html
   * 加载总时间
   * 这几乎代表了用户等待页面可用的时间
   * loadEventEnd（加载结束）-navigationStart（导航开始）
   */

  setTimeout(function() {
    try {
      const perftiming = performance.timing
      timing.loadEventEnd = perftiming.loadEventEnd
      timing.loadEventStart = perftiming.loadEventStart
      timing.loadTime = timing.loadEventEnd - timing.navigationStart
      resolve(timing)
    } catch (error) {
      console.error('timing setting error', error)
      resolve(timing)
    }
  }, 0)
})

const initPagePerformance = async() => {
  try {
    const channelId = process.env.VUE_APP_LOCAL === 'Q' ? 'qunar' : getChannelInfo().channelId
    // const platform = getPlatform().platformValue
    const pageId = urlHelper.queryString('id')
    const timing = await getTiming()
    const metrics = []
    const timingKeys = ['domReadyTime', 'loadTime']
    timingKeys.forEach((key) => {
      const time = timing[key]
      if (time) {
        metrics.push({
          // name: `${channelId}.${platform}.${pageId}.${key}`,
          name: `${channelId}.${pageId}.${key}`,
          value: time,
          type: 'time'
        })
      }
    })
    if (timing.domReadyTime) {
      if (timing.domReadyTime <= 1000) {
        metrics.push({
          name: `${channelId}.${pageId}.fastReadyTime_Count`,
          value: 1,
          type: 'count'
        })
      }
      metrics.push({
        name: `${channelId}.${pageId}.domReadyTime_Count`,
        value: 1,
        type: 'count'
      })
    }
    sendWatcher(metrics)
  } catch (error) {
    console.log(error)
  }
}

if (window.document.readyState === 'complete') {
  initPagePerformance()
} else {
  window.addEventListener('load', () => {
    initPagePerformance()
  })
}
